// Calendar days are pinned to noon UTC so the regression x-values (and so every
// dollar figure) are identical in the browser and in the PDF renderer, whatever
// the timezone or DST rules of the machine doing the math.
function calendarDay(year: number, monthIndex: number, day: number): Date {
  return new Date(Date.UTC(year, monthIndex, day, 12));
}

const ISO_DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseCalendarDate(value: string): Date {
  const match = ISO_DATE_ONLY.exec(value.trim());
  if (match) return calendarDay(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  const parsed = new Date(value);
  return isNaN(parsed.getTime())
    ? parsed
    : calendarDay(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}
